import {
  commonMutationTypes,
  commonPaginationTypes,
  OrderDirection,
  pageInfo,
} from "../../../../../../utils/commonQueryTypes";
import { TableType } from "../../../../customer/companies/queries/types";

export enum AtsAcLdgrOrderField {
  CREATED_AT = "CREATED_AT",
}

export enum AtsAcLdgrMultiLocationOrderField {
  CREATED_AT = "CREATED_AT",
  CITY = "CITY",
}

export enum LdgrQueryType {
  ALL = "ALL",
  LDGRS_ASSOIC_ITEM = "LDGRS_ASSOIC_ITEM",
  LDGRS_NOT_ASSOIC_ITEM = "LDGRS_NOT_ASSOIC_ITEM",
  LDGRS_ASSOIC_TO_SITE = "LDGRS_ASSOIC_TO_SITE",
  LDGRS_NOT_ASSOIC_TO_SITE = "LDGRS_NOT_ASSOIC_TO_SITE",
}

export interface LdgrQueryData {
  query_type: LdgrQueryType;
  itemID: number;
  tableLevel: TableType | undefined;
}

export interface GetSuppliersVars extends commonPaginationTypes {
  customer_id: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsAcLdgrOrderField;
  };
  input: LdgrQueryData;
  name: string;
}

export interface AtsAcLdgrDetails {
  id: number;
  address: string;
  city: string;
  pin: string;
  state: string;
  country: string;
  email: string;
  phone: string;
  gstNo: string;
  tanNo: string;
  vatNo: string;
  panNo: string;
  bankAcNo: string;
  bankName: string;
  bankBranch: string;
  bankIfsc: string;
  bankMicr: string;
  contactPerson: string;
  contactPersonAddress: string;
  contactPersonCity: string;
  contactPersonPin: string;
  contactPersonState: string;
  contactPersonCountry: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  contactPersonAadhar: string;
  alterContactPerson: string;
  alterContactPersonEmail: string;
  alterContactPersonMobile: string;
  alterContactPersonAadhar: string;
  proficiency: string;
  avgRating: string;
  lastSupplyRefNo: string;
  lastSupplyRating: string;
  lastSupplyRemarks: string;
  lastSupplyDate: string;
}

export interface AtsAcLdgr {
  id: number;
  desc: string;
  multiLocation: boolean;
  itemsCount: number;
  empCount: number;
  includeDeviceType: boolean
  supplier_details: AtsAcLdgrDetails;
}

export interface AtsAcLdgrEdge {
  node: AtsAcLdgr;
  cursor: string;
}

interface GetSuppliersData {
  edges: AtsAcLdgrEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetSuppliersResult {
  GetSuppliers: GetSuppliersData;
}

export interface AtsAcLdgrMultiLocation {
  id: number;
  address: string;
  city: string;
  pin: string;
  state: string;
  country: string;
  email: string;
  phone: string;
  gstNo: string;
  tanNo: string;
  vatNo: string;
  panNo: string;
  contactPerson: string;
  contactPersonAddress: string;
  contactPersonCity: string;
  contactPersonPin: string;
  contactPersonState: string;
  contactPersonCountry: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  contactPersonAadhar: string;
}
export interface GetSupplierMultiLocationVars extends commonPaginationTypes {
  customer_id: number;
  supplier_id: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsAcLdgrMultiLocationOrderField;
  };
  name: string;
}

export interface AtsAcLdgrMultiLocationEdge {
  node: AtsAcLdgrMultiLocation;
  cursor: string;
}

export interface GetSupplierMultiLocationData {
  edges: AtsAcLdgrMultiLocationEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetSupplierMultiLocationResult {
  GetSupplierMultiLocation: GetSupplierMultiLocationData;
}

//Mutations
export interface CreateAtsAcLdgrDetailsInput {
  gstNo: string;
  tanNo: string;
  panNo: string;
  vatNo: string;
  bankAcNo: string;
  bankName: string;
  bankBranch: string;
  bankIfsc: string;
  bankMicr: string;
  proficiency: string;
  alterContactPerson: string;
  alterContactPersonMobile: string;
  alterContactPersonEmail: string;
  alterContactPersonAadhar: string;

  // Additional fields (optional)
  address?: string;
  city?: string;
  pin?: string;
  state?: string;
  supplieName?: string;
  country?: string;
  email?: string;
  phone?: string;
  contactPerson?: string;
  contactPersonAddress?: string;
  contactPersonCity?: string;
  contactPersonPin?: string;
  contactPersonState?: string;
  contactPersonCountry?: string;
  contactPersonEmail?: string;
  contactPersonMobile?: string;
  contactPersonAadhar?: string;
}

export interface AddSupplierVar extends commonMutationTypes {
  customer_id: number;
  supplier_name: string;
  multi_location: boolean;
  includeDeviceType: boolean;
  input: CreateAtsAcLdgrDetailsInput;
}

export interface AddSupplierResult {
  AddSupplier: {
    id: number;
  };
}

export interface UpdateSupplierVar extends commonMutationTypes {
  customer_id: number;
  supplier_id: number;
  includeDeviceType?: boolean
  input: CreateAtsAcLdgrDetailsInput;
}

export interface UpdateSupplierResult {
  UpdateSupplier: boolean;
}

export interface CreateAtsAcLdgrMultiLocationInput {
  address: string;
  city: string;
  pin: string;
  state: string;
  country: string;
  email: string;
  phone: string;
  gstNo: string;
  tanNo: string;
  vatNo: string;
  panNo: string;
  contactPerson: string;
  contactPersonAddress: string;
  contactPersonCity: string;
  contactPersonPin: string;
  contactPersonState: string;
  contactPersonCountry: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  contactPersonAadhar: string;
}

export interface AddSupplierMultiLocationVar extends commonMutationTypes {
  customer_id: number;
  supplier_id: number;
  input: CreateAtsAcLdgrMultiLocationInput;
}

export interface AddSupplierMultiLocationResult {
  AddSupplierMultiLocation: boolean;
}

export interface UpdateSupplierMultiLocationVar extends commonMutationTypes {
  supplier_multi_loc_id: number;
  input: CreateAtsAcLdgrMultiLocationInput;
}

export interface UpdateSupplierMultiLocationResult {
  UpdateSupplierMultiLocation: boolean;
}

export interface DeleteSupplierMultiLocationVar extends commonMutationTypes {
  supplier_multi_loc_id: number;
}

export interface DeleteSupplierMultiLocationResult {
  DeleteSupplierMultiLocation: boolean;
}

export interface DeleteSupplierByIdResult {
  DeleteSupplier: boolean;
}

export interface DeleteSupplierByIdVars extends commonMutationTypes {
  customer_id: number;
  supplier_ids: number[];
}

export interface GetRfqTrnSupplyNodeVars {
  id: number;
  key: string;
}

export interface GetRfqTrnSupplyNodeResult {
  GetRfqTrnSupplyNode: {
    id: number;
    isAccepted: boolean;
    quotedAnyChanges: boolean;
    itemDescChanged: boolean;
    quotedDesc: string;
    quotedQty: number;
    quotedRate: number;
    quotedRemarks: string;
    quotedDelvChrg: number;
    quotedInstChrg: number;
    quotedTax: number;
    quotedOther: number;
    item: {
      desc: string;
      code: string;
    };
    rfqTrn: {
      udfItemDesc: string;
      itemPaymentTerms: string;
      mrf_trn_details: {
        reqQty: string;
      };
    };
  };
}
